import { trackingService } from "../services/tracking.service";

export async function getIP(): Promise<string> {
  try {
    const response = await fetch("https://api.ipify.org?format=json");
    const data = await response.json();

    return data?.ip || "";
  } catch (error) {
    console.warn("Error fetching IP address:", error);
    trackingService.captureMessage(
      `${window.location.host} | Could not get IP from ipify.org - for a.cloud.dive.games API. Proceed the request with no user IP.`,
      "warning"
    );
    return "";
  }
}
